import { useEffect } from 'react';

export default function GoogleReviewsSection() {
  useEffect(() => {
    const existingScript = document.getElementById('elfsight-platform-script');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'elfsight-platform-script';
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="google-reviews" className="py-16 lg:py-24" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f0fafa 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-2xl px-6 py-3 shadow-sm mb-4">
            <svg viewBox="0 0 48 48" className="w-7 h-7 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C6.51 42.62 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              <path fill="none" d="M0 0h48v48H0z"/>
            </svg>
            <span className="text-sm font-bold text-gray-700 tracking-wide">Google Reviews</span>
          </div>

          <p className="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-3">Trusted by Homeowners Across Las Vegas</p>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0f1f3d] mb-4 leading-tight">
            Las Vegas Trusts <span className="text-cyan-500">Leak Detectives</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto mb-4">
            Real reviews from real customers across Las Vegas — updated live from Google.
          </p>
          <a
            href="https://www.google.com/search?q=Leak+Detectives+Las+Vegas+reviews"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-cyan-500 text-white px-7 py-3 rounded-lg font-bold text-sm hover:bg-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-google-fill text-base"></i> Leave Us a Review
          </a>
        </div>

        {/* Live Google Reviews Widget */}
        <div className="w-full relative">
          <div
            className="elfsight-app-93247972-6772-4b68-9c4b-e985106d6902"
            data-elfsight-app-lazy
          ></div>
          {/* Cover Elfsight branding */}
          <div
            className="absolute bottom-0 left-0 right-0 h-8 pointer-events-none"
            style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f0fafa 100%)' }}
          ></div>
        </div>

      </div>
    </section>
  );
}
